import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 16 16"
  }, props),
  /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M7.696 4.683a.43.43 0 0 1 .608 0l3.013 3.013a.43.43 0 0 1 0 .608l-3.013 3.013a.43.43 0 1 1-.608-.608L9.974 8.43H4.987a.43.43 0 1 1 0-.86h4.987L7.696 5.29a.43.43 0 0 1 0-.608"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M7.519 4.506a.68.68 0 0 1 .962 0l3.013 3.013a.68.68 0 0 1 0 .962l-3.013 3.013a.68.68 0 0 1-.962-.962L9.37 8.68H4.987a.68.68 0 1 1 0-1.36H9.37L7.52 5.468a.68.68 0 0 1 0-.962m.609.353a.18.18 0 0 0-.256.256l2.278 2.278a.25.25 0 0 1-.176.427H4.987a.18.18 0 1 0 0 .36h4.987a.25.25 0 0 1 .176.427l-2.278 2.278a.18.18 0 0 0 .256.255l3.012-3.012a.18.18 0 0 0 0-.256z"
    }
  ))
);
var SvgCircledArrowRightOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledArrowRightOutlined_default = SvgCircledArrowRightOutlined;

export { CircledArrowRightOutlined_default as default };
